export default __webpack_public_path__ + "static/media/under_construction.7b3189d8.gif";